<div [formGroup]="widgetFormInstance">
    <dls-multiselect 
      formControlName="{{config.name}}"
      placeholder="{{config.placeholder | stringTranslate}}"
    >
      <ng-template #value let-selectedValues>
        <span>{{config.placeholder | stringTranslate}}</span>
      </ng-template>
      <ng-container *ngFor="let item of selectionItems | keyvalue">
        <ng-container *ngIf="isArray(item.value); else flat_list">
            <div class="pt-multiselect-option pt-option-group-label" style="font-weight: bolder;">{{item.key | stringTranslate}}</div>
            <dls-multiselect-option *ngFor="let subItem of item.value" [value]="subItem">
              <span class="pt-option-label">{{subItem?.display}}</span>
            </dls-multiselect-option>
        </ng-container>
        <ng-template #flat_list>
            <dls-multiselect-option [value]="item.value">
              <span class="pt-option-label">{{item.value?.display}}</span>
            </dls-multiselect-option>
        </ng-template>
      </ng-container> 
    </dls-multiselect>
    <dls-token 
      [ngModel]="widgetFormInstance.get(config.name).value" 
      [ngModelOptions]="{standalone: true}"
      field="display" 
      [editableTokenOnly]="true"
      (onRemove)="onRemove($event)"
    ></dls-token>
  </div>
  